import { memo, useCallback, useState } from "react"
import styled from "styled-components"
import clsx from "clsx"

const Wrapper = styled.div`
  min-height: 60px;
`

const SidebarItemHeader = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;

  &.isActive {
    background: rgba(231, 231, 252, 0.4);
    cursor: default;

    &:hover {
      background: rgba(231, 231, 252, 0.4);
    }
  }

  &:hover {
    background: rgba(231, 231, 252, 0.1);
  }
`

const SidebarItemContent = styled.div`
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;

  &.open {
    max-height: 600px;
  }

  .secondLevel {
    margin-left: 16px;
  }
`

const ArrowWrapper = styled.span`
  display: inline-block;
  transition: transform 0.3s ease;
  transform: rotate(-180deg);

  &.noSubItems {
    display: none;
  }

  &.open {
    transform: rotate(0deg);
  }
`

const IconWrapper = styled.div`
  width: 32px;
  display: flex;
  justify-content: center;
`

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 32px 1fr;
  align-items: center;
  gap: 16px;
  transition: transform 0.3s ease-out;

  &.noIcon {
    margin-left: 48px;
    grid-template-columns: 1fr;
  }

  &.isHovered {
    transform: translateX(-4px);
  }
`

interface SidebarItemProps {
  title: React.ReactNode
  children?: React.ReactNode
  icon?: React.ReactNode
  hasSubItems?: boolean
  onClick?: () => void
  hideArrow?: boolean
  collapsed?: boolean
  isActive?: boolean
}

const SidebarItem: React.FC<SidebarItemProps> = (props) => {
  const { title, children, icon, hasSubItems, onClick, hideArrow, collapsed, isActive } = props

  const [isOpen, setIsOpen] = useState(false)
  const [isHovered, setIsHovered] = useState(false)

  const toggle = useCallback(() => setIsOpen(!isOpen), [isOpen])

  const handleClick = useCallback(() => {
    if (hasSubItems) {
      toggle()
    }

    if (onClick) {
      onClick()
    }
  }, [hasSubItems, onClick, toggle])

  const handleMouseEnter = useCallback(() => {
    setIsHovered(!isActive)
  }, [isActive])

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false)
  }, [])

  return (
    <Wrapper>
      <SidebarItemHeader
        onClick={handleClick}
        className={clsx({ isActive })}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <TitleWrapper className={clsx({ noIcon: !icon, isHovered })}>
          {!!icon && <IconWrapper>{icon}</IconWrapper>}
          {!collapsed ? title : null}
        </TitleWrapper>
        {!hideArrow && !collapsed && (
          <ArrowWrapper className={clsx({ open: isOpen, noSubItems: !hasSubItems })}>
            {/* <IconWhiteCaretDown /> */}
            {"icon"}
          </ArrowWrapper>
        )}
      </SidebarItemHeader>
      {!collapsed && <SidebarItemContent className={clsx({ open: isOpen })}>{children}</SidebarItemContent>}
    </Wrapper>
  )
}

export default memo(SidebarItem)
